import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { EditSchema } from './schema';
import View from './View';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { getBaseUrl, flattenToAppURL } from '@plone/volto/helpers';
import { Api } from '@plone/volto/helpers';


const Edit = (props) => {
  const { block, data, selected } = props;
  const intl = useIntl();
  const schema = EditSchema(intl);

  const dispatch = useDispatch();
  const token = useSelector((state) => state.userSession.token, shallowEqual);

  const prePopulateFields = (schema) => {
    const initialValues = {};
    Object.keys(schema.properties).forEach((key) => {
      if (schema.properties[key].hasOwnProperty('initialValue')) {
        initialValues[key] = schema.properties[key].initialValue;
      }
    });
    props.onChangeBlock(block, {
      ...initialValues,
      ...data,
    });
  };

  React.useEffect(() => {
    prePopulateFields(schema);
  }, []);

  const handleChange = (id, value) => {
    props.onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  const [items, setItems] = useState(data.elems || []);


  const apiGetContent = async (pathname) => {
    const api = new Api();
    const allItems = [];

    // Function to fetch items and their children
    const fetchItem = async (path) => {
      if (!path) return;
      try {
        const promise = await api.get(flattenToAppURL(path));
        const items = promise.items
        allItems.push(...items);
        if (promise.batching?.next) {
          await fetchItem(promise.batching.next);
        }
      } catch (error) {
        return
      };
    }
    await fetchItem(pathname)
    /*     console.log(await fetchItem("http://localhost:3000/de/partner/ccs_partner_ukd.png"));
     */
    if (items.length !== allItems.length)
      setItems(allItems);
    return;
  };

  useEffect(() => {
    if (data.usePath)
      apiGetContent(data.load);
    /* if(!data.usePath)
      setItems(data.elems); */
  }, [token, dispatch, data.load, data.usePath]);

  useEffect(() => {

    if(!items || !data.usePath) return;
    const newAr = items.map((item) => ({
      "@id": `${item['@id']}`,
      image: item,
      link: item.description
    }));
    console.log("changed", newAr);
    handleChange("elems", newAr)
  }, [items]);

  return (
    <>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          onChangeField={handleChange}
        />
      </SidebarPortal>
      <View data={data} edit={true} handleChange={handleChange} />
    </>
  );
};
export default Edit;